import http from '@/utils/http'
import type {
  LoginParams,
  LoginResult,
  AutoLoginParams,
  UserInfoModel,
  Menu,
  FollowParams,
  FollowListParams,
  FollowListItem,
  UnFollowParams,
} from './model/userModel'

enum Source {
  LOGIN = '/login/password',
  AUTO_LOGIN = '/login/auth-code',
  LOGOUT = '/auth/logout',
  GET_USER_INFO = '/user-info',
  PERMISSION_TREE = '/permission-tree',
  FOLLOW_MENU = '/base/web/favorites-list/add',
  FOLLOW_MENU_LIST = '/base/web/favorites-list/list',
  UNFOLLOW_MENU = '/base/web/favorites-list/cancel-and-delete',
  // wcsJumpUrl
  WCS_JUMP_URL = '/base/web/wcs/wcs-jump-url',
  // 检测当前系统是否配置了rainbow链接
  RAINBOW_LINK_CHECK = '/base/web/user-login-log/get-region-grayscale-url',
}

/**
 * 登录
 * @param data 参数
 * @returns Promise<LoginRes>
 */
export const login = (data: LoginParams) =>
  http.post<LoginResult>({ url: Source.LOGIN, data }, { errorMessageMode: 'none' })

/**
 * fbg自动登录
 * @param data 参数
 * @returns Promise<LoginRes>
 */
export const autoLogin = (data: AutoLoginParams) =>
  http.post<LoginResult>({ url: Source.AUTO_LOGIN, data }, { errorMessageMode: 'none' })

/**
 * 登出
 * @returns
 */
export const logout = () => http.get({ url: Source.LOGOUT })

/**
 * 获取用户信息
 * @returns
 */
export const getUserInfo = () => http.post<UserInfoModel>({ url: Source.GET_USER_INFO })

/**
 * 获取用户权限
 * @returns
 */
export const getMenu = () =>
  http.post<Menu[]>({
    url: Source.PERMISSION_TREE + '?source=PC',
  })

/**
 * 获取收藏菜单列表
 * @returns
 */
export const getFollowedMenuList = (data: FollowListParams) =>
  http.post<FollowListItem[]>({ url: Source.FOLLOW_MENU_LIST, data })

/**
 * 收藏菜单
 * @returns
 */
export const followMenuApi = (data: FollowParams) => http.post({ url: Source.FOLLOW_MENU, data })

/**
 * 取消收藏
 * @returns
 */
export const unFollowMenuApi = (data: UnFollowParams) =>
  http.post({ url: Source.UNFOLLOW_MENU, data })

/**
 * 获取wcs跳转url
 * @returns
 */
export const wcsJumpUrlApi = () => http.post<string>({ url: Source.WCS_JUMP_URL })

/**
 * 检测当前系统是否配置了rainbow链接
 * @returns
 */
export const rainbowLinkCheckApi = (regionWarehouseCode: string) =>
  http.post<{ siteUrl: string }>({ url: Source.RAINBOW_LINK_CHECK, data: { regionWarehouseCode } })
